export { default } from "./TabBar";
